import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { StatusRo } from './status-ro';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

// import { Component, OnInit } from '@angular/core';
// import { BaseUpdateComponent} from 'yt-ng-framework';

// import { StatusRo } from './status-ro';
// import { UpdateComponentImports} from '../../update_component_imports'

@Component({
  selector: 'yt-status-ro-update',
  templateUrl: './status-ro-update.component.html'
})

export class StatusRoUpdateComponent 
extends BaseUpdateComponent<StatusRo> 
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  // constructor(
  //   protected updateComponentImports: UpdateComponentImports,
  // ) {
  //   super(updateComponentImports);
  // }


  ngOnInit() {
    super.ngOnInit();
    //this.addValidatorToFc('Naziv', Validators.required, 'required', 'SRODSTVO.NAZIV.VALIDATION.REQUIRED');
    //this.addValidatorToFc('Naziv', Validators.maxLength(50), 'maxlength', 'SRODSTVO.NAZIV.VALIDATION.MAXLENGTH');
  }

}
